module.exports = __webpack_public_path__ + "0cc030e66b4d35cb7829b1bbd5a9014a.png";